import React from 'react';
import { Button } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useRequestDrawer } from '../../context/RequestDrawerContext';

interface ViewPriceChangeRequestButtonProps {
    requestId: string;
}

export function ViewPriceChangeRequestButton({
    requestId,
}: ViewPriceChangeRequestButtonProps) {
    const { open } = useRequestDrawer();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        open(null, requestId);
    };

    return (
        <Button
            variant="transparent"
            onClick={handleClick}
            rightSection={<IconArrowRight size={14} />}
            className="text-primary hover:bg-transparent hover:underline text-sm font-medium h-auto py-0 px-0 w-fit"
        >
            View Price Change Request
        </Button>
    );
}
